import React,{Component} from 'react'

class Columns extends Component{

  constructor(props){
    super(props);
  }

  componentDidMount = () => {

  }

  renderColumns = () => {
    const {children,cols} = this.props;
    const count = cols || 3;

    let modulo = 0;
    let columns = []

    if(children.length == 0){
      return null;
    }

    for (let i = 1; i <= count; i++) {
      let elements = (
        <div key={`column-${i}`} className={`column-${count}`}>
          {children.filter((el,idx) => idx%count == modulo)}
        </div>
      );
      columns.push(elements)
      modulo++;
    }

    return columns;
  }

  render(){
    return (
      <div className='column-wrapper'>
        {this.renderColumns()}
      </div>
    )
  }
}

export default Columns



// WEBPACK FOOTER //
// ./src/components/Columns.js